import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { linkHandler } from 'utils/linkHandler';

const cooperations = {};

export const CooperationLogo = () => {
  const location = useLocation();
  const cooperation = useMemo(() => {
    for (const key in cooperations) {
      const route = linkHandler.getRoute(key);
      if (route && location.pathname === route.path) {
        return cooperations[key];
      }
    }
    return null;
  }, [location]);

  if (!cooperation) {
    return null;
  }

  return (
    <a className="brand-logo" target="_blank" rel="noopener noreferrer" href={cooperation.url}>
      <img src={cooperation.logo} alt={cooperation.altText} />
    </a>
  );
};
